import React from "react";
import classnames from "classnames";
import PageMetaTags from "../common/page-meta-tags/PageMetaTags";
import Welcome from "./welcome/Welcome";
import OurValues from "./our-values/OurValues";
import Benefits from "./benefits/Benefits";
import LifeatVahak from "./lifeat-vahak/LifeatVahak";
import Stories from "./stories/Stories";
import ExploreJobs from "./explore-jobs/ExploreJobs";
import Located from "./located/Located";
import { Categ, JobsResponse } from "@vahak/core/dist/_services/careers.service";
import Styles from "./Careers.module.scss";
import A from "@vahak/core/dist/components/app-anchor/A";
import { IMG_BASE_URL } from "@vahak/core/dist/constants/misc";
interface CareersProps {
    jobs: JobsResponse["jobs"] | null;
    meta: any;
    categs: Categ[];
}

const Careers = ({ jobs, meta, categs }: CareersProps) => {
    return (
        <>
            <PageMetaTags
                title="Vahak - Careers"
                description="Vahak helps Logistic companies to connect with Truck Owners, Brokers, and other Transporters from All India. A Branding & Networking tool for Indian Transport Industry. The online brand coupled with the huge network creates wonderful opportunities especially for small and medium scale transport businesses to grow."
                canonicalUrl="https://www.vahak.in/careers"
                ogUrl="https://www.vahak.in/careers"
                ogImgAltText="Book Trucks, Containers from Thousands of Trusted Transport businesses and Lorry Owners from All India"
                schemaOrgJsonUrl="/careers"
                includeDefaultSchema={false}
                schemaType="WebPage"
            />

            <div className={Styles.careersPageWrap}>
                <section id="welcome" className={classnames(Styles.welcomeSection, Styles.sections, "flipAnimate")}>
                    <div className="container">
                        <Welcome />
                    </div>
                </section>

                <section id="values" className={classnames(Styles.ourValueSection, Styles.sections, "flipAnimate")}>
                    <div className="container">
                        <OurValues />
                    </div>
                </section>

                <section id="benefits" className={classnames(Styles.benefitsSection, Styles.sections, "flipAnimate")}>
                    <div className="container">
                        <Benefits />
                    </div>
                    <p className={classnames(Styles.jd)}>
                        To know more about us, our culture and what’s in store for you{" "}
                        <A openInNewTab href={IMG_BASE_URL + "/1JD.pdf"}>
                            click here
                        </A>
                    </p>
                </section>

                <section id="life" className={classnames(Styles.lifeatVahakSection, Styles.sections, "flipAnimate")}>
                    <LifeatVahak />
                </section>

                <section
                    id="stories"
                    className={classnames(Styles.storiesSection, Styles.sections, "flipAnimate", "container")}
                >
                    <Stories />
                </section>

                <section id="jobs" className={classnames(Styles.exploreJobSection, Styles.sections, "flipAnimate")}>
                    <div className="container">
                        <ExploreJobs jobsData={jobs} meta={meta} categories={categs} />
                    </div>
                </section>

                <section id="location" className={classnames(Styles.locationSection, Styles.sections, "flipAnimate")}>
                    <div className="container">
                        <Located />
                    </div>
                </section>
            </div>
        </>
    );
};

export default Careers;
